import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiUploadFile(formData: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/file/upload`, formData);
}

export function apiDownloadFile(fileName: any): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/files/${fileName}`, { responseType: 'arraybuffer' });
}
